import { type Slot } from '../services/appointment/model';

export const hasPendingSlot = (
  slot?: Slot,
  replacementServiceSlot?: Slot,
): boolean => {
  return (
    slot?.status === 'pending' || replacementServiceSlot?.status === 'pending'
  );
};

export const isCompleted = (slot?: Slot): boolean => {
  return slot?.status === 'completed';
};

export const getSlotByDate = (
  date: string,
  slots: Slot[],
  replacementServiceSlots: Slot[],
): { slot?: Slot; replacementServiceSlot?: Slot } => {
  const slot = slots.find((s) => s.date === date);
  const replacementServiceSlot = replacementServiceSlots.find(
    (s) => s.date === date,
  );
  return { slot, replacementServiceSlot };
};

export const getFirstTimeSlotId = (slot?: Slot): string => {
  return slot?.timeSlots[0]?.id || '';
};
